import {classNames} from "../lib/functions";

export default function Block({ style = {}, children, className = '' }) {
  return <div style={style} className={
    classNames(className, "w-full", 'mx-auto')
  }>{children}</div>
}
